define(["jquery"], function ($) {
    function Init() {
        var usingFacet = false;

        $("body").click(function () {
            if (!usingFacet) {
                $(".opened", $(".score-facet-panel")).next().slideToggle();
                $(".opened", $(".score-facet-panel")).attr("aria-expanded", $(".opened", $(".score-facet-panel")).hasClass("opened"));
                $(".opened", $(".score-facet-panel")).toggleClass("opened").toggleClass("closed");
            }
        });
        $(".score-facet-panel").on("click", function () {
            usingFacet = true;
            setTimeout(function () { usingFacet = false; }, 350);
        });                
    }

    return {        
        Init: Init 
    };
});